/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_All_Applied_B_To_AInputs */



/**
* | output |
* | --- |
* | "All changes applied from Group B to Group A" |
*
* @param {Compare_Event_Groups_All_Applied_B_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_all_applied_b_to_a = /** @type {((inputs?: Compare_Event_Groups_All_Applied_B_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_All_Applied_B_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les modifications s'appliquent du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Änderungen wurden von Gruppe B auf Gruppe A übertragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le modifiche sono state applicate dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все изменения внесены из группы B в группу A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los cambios se aplicaron del Grupo B al Grupo A.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有变更均从B组变更至A组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての変更はグループBからグループAに適用されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ग्रुप बी से ग्रुप ए में सभी बदलाव लागू किए गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todas as alterações foram aplicadas do Grupo B ao Grupo A.")
	return /** @type {LocalizedString} */ ("All changes applied from Group B to Group A")
});